import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import Guid from "_shared/guids/guid";
import IndividualAvatar from "marketplace/_views/avatars/individual-avatar";
import { getIndividualsByUserIds } from "marketplace/individuals/_stores/individuals-redux-slice";
import { useSelector } from "react-redux";
import NetworkedGroup from "users/networking/groups/networked-group";

interface AvatarGroupProps {
  group: NetworkedGroup;
  avatarGroupMax?: number;
}

const DEFAULT_AVATAR_GROUP_MAX = 5;

export default function NetworkedGroupAvatarGroup(props: Readonly<AvatarGroupProps>) {

  const { group, avatarGroupMax } = props;

  const individuals = useSelector(getIndividualsByUserIds(group.memberUserIds));

  return (
    <AvatarGroup max={avatarGroupMax ?? DEFAULT_AVATAR_GROUP_MAX}>
      {individuals?.map((individual) => {
        if (!individual) return <Avatar key={Guid.generate().value} />;
        return (
          <IndividualAvatar
            key={individual?.userId?.value}
            individual={individual}
          />
        );
      })}
    </AvatarGroup>
  );
}
